import styled from 'styled-components'
import Text from '../atoms/Text'
import { formatUtcToLocalTime } from '../../utils/fomratUtcToLocalTime'
import { formatDuration } from '../../utils/formatDuration'

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;
  border-radius: 20px;
  padding: 16px;
  gap: 12px;
  background-color: ${({ theme }) => theme.colors.neutral[100]};
`
const DateWrapper = styled.div`
  display: flex;
  gap: 4px;
  margin-top: 4px;
`
const Chip = styled.div`
  padding: 4px;
  border-radius: 4px;
  border: ${({ $isRegister, theme }) => ($isRegister ? 'none' : `1px solid ${theme.colors.neutral[400]}`)};
  // border: ${({ isRegister, theme }) => (isRegister ? `1px solid ${theme.colors.status.info}` : `1px solid ${theme.colors.neutral[400]}`)};
  // border: ${({ isRegister, theme }) => `1px solid ${theme.colors.neutral[400]}`};
  border-radius: 4px;
  background-color: ${({ $isRegister, theme }) => $isRegister ? `#EAF3FE`: theme.colors.neutral[200]};
  // background-color: ${({ isRegister, theme }) => theme.colors.neutral[200]};
  // background-color: ${({ isRegister, theme }) => isRegister ? `#E6F5EC`: theme.colors.neutral[200]};

  width: auto;
  display: flex;
  align-items: center;
  align-self: flex-start; 
`
const ConversationItem = ({ data, onClick }) => {
  const isRegister = data.mappingYn ? true : false;
  const chipLabel = isRegister ? '검토 완료' : '검토 전'
  const recordedAt = formatUtcToLocalTime(data.createdAt)
  const totalTime = formatDuration(data.totalTime)
  
  return (
    <Container onClick={onClick}>
      <Chip $isRegister={isRegister}>
        <Text 
          variant="caption"
          weight="medium"
          color={isRegister? 'info' : 'alternative'}>
            {chipLabel}
        </Text>
      </Chip>
      <>
        <Text variant="headline3" weight="medium">{data.title}</Text>
        <DateWrapper>
          <Text variant="body2" color="alternative">{recordedAt}</Text>
          <Text variant="body2" color="alternative">&#183;</Text>
          <Text variant="body2" color="alternative">{totalTime}</Text>
        </DateWrapper>
      </>
    </Container>
  )
}

export default ConversationItem